import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Dropdown, Form } from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import { namespaces, TRANSLATION_FILES } from '../constants/translation';

const DelistReasonModal = ({
  open,
  onConfirm,
  onCancel,
  reasons,
  selectedReason,
  onReasonChange,
  loading,
  t,
}) => {
  const reasonOptions = reasons.map(reason => ({
    key: reason.id,
    text: reason.label,
    value: reason.id,
  }));

  // "No Reason" option
  reasonOptions.unshift({
    key: '',
    text: t('No Reason'),
    value: '',
  });

  return (
    <Modal
      open={open}
      onClose={onCancel}
      size="tiny"
      closeIcon={!loading}
      closeOnDimmerClick={!loading}
    >
      <Modal.Header>
        {t('Delist Unit')}
      </Modal.Header>
      <Modal.Content>
        <Form>
          <Form.Field>
            <label>{t('Delist Reason')} ({t('Optional')})</label>
            <Dropdown
              placeholder={t('Select reason...')}
              fluid
              selection
              options={reasonOptions}
              value={selectedReason}
              onChange={(e, { value }) => onReasonChange(value)}
              disabled={loading}
            />
          </Form.Field>
          <p style={{ color: '#666', fontSize: '0.9em', marginTop: '10px' }}>
            {t('You can proceed without selecting a reason. This is optional.')}
          </p>
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button
          onClick={onCancel}
          disabled={loading}
        >
          {t('Cancel', { ns: TRANSLATION_FILES.translation })}
        </Button>
        <Button
          primary
          onClick={onConfirm}
          loading={loading}
          disabled={loading}
        >
          {t('Confirm', { ns: TRANSLATION_FILES.translation })}
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

DelistReasonModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  reasons: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  })).isRequired,
  selectedReason: PropTypes.string,
  onReasonChange: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  t: PropTypes.func.isRequired,
};

DelistReasonModal.defaultProps = {
  selectedReason: '',
  loading: false,
};

export default withTranslation(namespaces)(DelistReasonModal);



// WEBPACK FOOTER //
// ./src/components/DelistReasonModal.jsx